import styled from 'styled-components';

import { getPurpurSpacing, getPurpurTypography, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { sideSpacingOfHeaderFooter } from '../../OrderCart.styles';

export const CartTotalsNotificationContainer = styled.div`
    ${sideSpacingOfHeaderFooter};
    font-size: ${getPurpurTypography('scale50')};
    padding-top: ${getPurpurSpacing('250')};
    ${purpurMedia('md')`
        padding-top: ${getPurpurSpacing('300')};
    `}
`;
